@if (companySearchLoading) {
  <div class="company-search-actions flex vcenter">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
}

@if (companySearchBankAccounts.length > 0) {
  <p class="company-search-hint">
    {{ "CLIENT_BANK_ACCOUNT_EDIT.COMPANY_SEARCH_PICK_HINT" | translate }}
  </p>
  <div
    class="company-search-account-list"
    role="listbox"
    [attr.aria-label]="'CLIENT_BANK_ACCOUNT_EDIT.COMPANY_SEARCH_PICK_HINT' | translate"
  >
    @for (account of companySearchBankAccounts; track accountKey(account)) {
      <button
        type="button"
        class="company-search-account-button"
        role="option"
        [attr.aria-selected]="isCompanySearchAccountSelected(account)"
        [class.company-search-account-button--selected]="isCompanySearchAccountSelected(account)"
        (click)="selectCompanySearchAccount(account)"
      >
        <span class="account-option">
          <span class="account-number">{{ formatCompanySearchAccountNumber(account) }}</span>
          @if (account.bank_name) {
            <span class="account-bank">{{ account.bank_name }}</span>
          }
        </span>
      </button>
    }
  </div>
}
